import { render, staticRenderFns } from "./TheImportarCategorialLinae.vue?vue&type=template&id=0cedfd7f&"
import script from "./TheImportarCategorialLinae.vue?vue&type=script&lang=js&"
export * from "./TheImportarCategorialLinae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports